import React, { useState, useEffect } from "react";
import axios from "axios";
import { showSuccess } from "services/toast.service";
import { handleError, getAccessToken } from "utils";
import { useHistory, useLocation } from "react-router-dom";
import Button from "components/Button";
import { API_BASE_URL } from "config/constants";
import Modal from "react-modal";
import { ROLES } from "config/roles";

// components

const AddWebsites = ({ color }) => {
  const { pathname, state } = useLocation();
  const [modalIsOpen, setIsOpen] = useState(false);
  const [manager, setmanager] = useState([]);
  const [clients, setClients] = useState([]);

  const [assignedManager, setassignedManager] = useState({
    assign: "",
  });
  const [gettingData, setGettingData] = useState(false);

  const { data } = state || {};
  const history = useHistory();

  const isUpdate = pathname === "/admin/update-website";

  if (isUpdate && !data) {
    history.goBack();
  }
  const [approveid, setapproveid] = useState();

  const [submitClick, setSubmitClick] = useState(false);
  const [loading, setLoading] = useState(false);

  const [website, setWebsite] = useState(
    data || {
      name: "",
      client: "",
    }
  );

  const onChange = (e) => {
    setWebsite({ ...website, [e.target.name]: e.target.value });
  };

  const isValid = () => {
    if (!website.name) return false;
    if (!website.client) return false;

    return true;
  };

  const handleClick = () => {
    setSubmitClick(true);
    if (!isValid()) return;
    if (isUpdate) {
      updateClient(website);
    } else {
      addwebsite(website.name, website.client);
    }
  };

  const getManagers = async () => {
    try {
      setGettingData(true);
      const response = await axios.get(
        `${API_BASE_URL}/user/all_account_managers`,
        {
          method: "GET",
          headers: {
            authorization: getAccessToken(),
          },
        }
      );
      setGettingData(false);
      const apiData = response.data;
      setmanager(apiData.result.data);
    } catch (error) {
      setGettingData(false);
      handleError(error);
    }
  };

  useEffect(() => {
    getManagers();
  }, []);

  const addwebsite = async (name, client) => {
    try {
      setLoading(true);
      const clientValues = JSON.parse(client); 
      const response = await axios.post(
        `${API_BASE_URL}/website`,
        {
          name,
          assignedTo: clientValues.assignedTo,
          assignedToId: clientValues.assignedToId,
          userId: clientValues._id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            authorization: getAccessToken(),
          },
        }
      );
      setLoading(false);
      showSuccess(response?.data?.result?.message);
      history.push("/admin/websites");
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  };

  const updateClient = async (dataToUpdate) => {
    try {
      setLoading(true);
      const {client} = dataToUpdate;

      if(typeof client === "object") {
        dataToUpdate.assignedTo = client.assignedTo;
        dataToUpdate.assignedToId = client.assignedToId;
        dataToUpdate.userId = client._id;
      }

      const response = await axios.put(
        `${API_BASE_URL}/website`,
        { id: data._id, ...dataToUpdate },
        {
          headers: {
            "Content-Type": "application/json",
            authorization: getAccessToken(),
          },
        }
      );
      setLoading(false);
      showSuccess(response?.data?.result?.message);
      history.push("/admin/websites");
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  };

  useEffect(() => {
    getClient();
  }, []);

  const getClient = async () => {
    try {
      const responce = await axios.get(`${API_BASE_URL}/user?page=1`, {
        method: "GET",
        headers: {
          authorization: getAccessToken(),
        },
      });
      const apiData = responce.data;
      console.log("client is ", apiData);
      setClients(apiData.result.data.result.filter(e => [ROLES.Publisher, ROLES.Advertizer].includes(e.role)));
    } catch (error) {
      handleError(error);
    }
  };

  return (
    <>
      <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
        <div className="rounded-t bg-white mb-0 px-6 py-6">
          <div className="text-center flex justify-between">
            <h6 className="text-blueGray-700 text-xl font-bold">
              {isUpdate ? "Update Website" : "Add New Website"}
              <span className="text-blueGray-700 text-sm font-bold">
                {" "}
                (Fill in the details below)
              </span>
            </h6>
          </div>
        </div>
        <div className="flex-auto px-4 py-10 pt-0">
          <form>
            <h6 className="text-blueGray-400 text-sm mt-3 mb-6 font-bold uppercase px-4">
              Webiste Information
            </h6>
            <div className="flex flex-wrap">
              <div className="w-full lg:w-6/12 px-4">
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    Website Name
                  </label>
                  <input
                    type="text"
                    value={website.name}
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="name"
                    onChange={onChange}
                  />
                  {submitClick && !website.name && (
                    <div className="text-red-500 text-sm mt-1 font-semibold">
                      Webiste Name is required!
                    </div>
                  )}
                </div>
              </div>
              <div className="w-full lg:w-6/12 px-4">
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    Client Name
                  </label>

                  <select
                    onChange={onChange}
                    name="client"
                    value={website.client}
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  >
                    <option value="" selected>
                      Choose
                    </option>
                    {clients.map((e, index) => (
                      <option key={index} value={JSON.stringify(e)}>
                        {e.name}
                      </option>
                    ))}
                  </select>
                  {submitClick && !website.client && (
                    <div className="text-red-500 text-sm mt-1 font-semibold">
                      Client Name is required!
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="px-4">
              <Button
                title={isUpdate ? "UPDATE WEBSITE" : "ADD NEW WEBSITE"}
                handleClick={handleClick}
                loading={loading}
              />
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddWebsites;
